(function () {
    'use strict';

    angular
        .module('capacitacionCertificacionApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
